
/**
 * A function that creates the cart-item html.
 */
export const _getCartItemHTML = (item) => {

	const {
		Shopify,
		theme
 	} = window;

	const output = {
		price: '',
		variant: '',
	};

	// Set the variant-title.
	if (item.product_has_only_default_variant === false) {
		output.variant = `<div class="c-cart-item__subtitle">${ item.variant_title }</div>`;
	}

	// Set the price to display.
	if (item.final_price > item.discounted_price) {
		output.price = '<s>' + Shopify.formatMoney(item.final_price, theme.moneyFormat) + '</s><span class="is-on-sale">' + formatMoney(item.discounted_price, theme.moneyFormat) + '</span>';
	} else if (item.compare_at_price > item.final_price) {
		output.price = '<s>' + Shopify.formatMoney(item.compare_at_price, theme.moneyFormat) + '</s><span class="is-on-sale">' + formatMoney(item.final_price, theme.moneyFormat) + '</span>';
	} else {
		output.price = Shopify.formatMoney(item.final_price, theme.moneyFormat)
	}

	// Create item-element and all of the necessary attributes.
	const newItemElement = document.createElement('li');
	newItemElement.classList.add('c-modal-cart__item', 'js-cart-item');
	newItemElement.dataset.lineItemKey = item.key;

	newItemElement.innerHTML = `
		<div class="c-modal-cart-item">
			<a class="c-modal-cart-item__image" href="${ item.url }">
				<img src="${ item.image }" />
			</a>

			<div class="c-modal-cart-item__content">
				<div class="c-modal-cart-item__content-header">
					<a class="c-modal-cart-item__title" href="${ item.url }">
						${ item.product_title }
					</a>
				</div>

				<div class="c-modal-cart-item__count">
					<button class="c-modal-cart-item__decrement js-quantity-remove" type="button">-</button>
					<input class="c-modal-cart-item__number" type="number" min="0" max="8" value="${ item.quantity }">
					<button class="c-modal-cart-item__increment js-quantity-add" type="button">+</button>
				</div>

				<div class="c-modal-cart-item__price">
					${ output.price }
				</div>
			</div>
		</div>
	`;

	return newItemElement;
}
